import { AxiosInstance } from 'axios'
import { IExportResponse } from '../../../types/importExport.types'

export function usersExportApiFactory(api: AxiosInstance) {
  const baseUrl = '/api/v1/export/users'

  const methods = {
    getAll() {
      return api.get<IExportResponse[]>(`${baseUrl}`)
    },
    getExport(exportId: number) {
      return api.get<IExportResponse>(`${baseUrl}/${exportId}`)
    },
    triggerExport(includeDeleted: boolean, filter: string | undefined) {
      let url = `${baseUrl}?include_deleted=${includeDeleted}`
      if (filter) {
        url = `${url}&filter=${filter}`
      }
      return api.post<IExportResponse>(url, {})
    },
    async getDownloadLink(exportId: number, filename: string): Promise<HTMLAnchorElement | undefined> {
      return api.get(`${baseUrl}/${exportId}/file`, {
        responseType: 'blob'
      }).then((response) => {
        const blob = new Blob([ response.data ], { type: 'text/csv' })
        const downloadLink = document.createElement('a')
        downloadLink.href = URL.createObjectURL(blob)
        downloadLink.download = filename
        return downloadLink
      })
    }
  }
  return methods
}
